/**
 * Created by jonas on 2022-10-27.
 */
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";

export class RestoreUtils {

    constructor() {

    }

    public static startupGame() {
        //ebugger;
        //Same for all
        //DevilsCrossRoad.backgroundElements.switchLevel(DevilsCrossRoad.model.data.currentLevel);
        //DevilsCrossRoad.reelView.switchLevel(DevilsCrossRoad.model.data.currentLevel);

        if (DevilsCrossRoad.model.initData.isRestoreState) {
            //Same for all restore
            //DevilsCrossRoad.keypadPlugin.setWin(DevilsCrossRoad.model.data.accumulatedRoundWin,true,DevilsCrossRoad.isWinBelowStake());

            if (DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.FREESPIN) {

                DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.FREESPIN);
                DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.FREESPIN);
                DevilsCrossRoad.freespinReelAreaView.initReels();
                DevilsCrossRoad.freespinUnlockAreas.activateAnimation("top");
                DevilsCrossRoad.freespinCollectorView.show(DevilsCrossRoad.model.data.collectMeter);
                //DevilsCrossRoad.freespinCollectorView.updateCollect(DevilsCrossRoad.model.data.collectMeter);

               // if (!DevilsCrossRoad.model.isSuperFreespin()) {
                //    RestoreUtils.restoreSuperFreespinWithIntro(DevilsCrossRoad.model.nextSpinMode());
               // } else {
              //      RestoreUtils.restoreSuperFreespin(DevilsCrossRoad.model.nextSpinMode());
             //   }
            //}
            //else if (DevilsCrossRoad.model.isNextFreeSpin()) {
              //  RestoreUtils.restoreFreespin(DevilsCrossRoad.model.nextSpinMode());
            //}
            //else if (DevilsCrossRoad.model.data.nextMode == GameMode.AVALANCHE_NORMAL) {
              //  RestoreUtils.restoreDuringAvalanche()
            }
            else if(DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
                DevilsCrossRoad.reelFrameView.switchReelFrame(DevilsCrossRoadGameMode.SUPER_FREESPIN);
                DevilsCrossRoad.freespinReelAreaView.switchReelMode(DevilsCrossRoadGameMode.SUPER_FREESPIN);
                DevilsCrossRoad.freespinReelAreaView.initReels();
                DevilsCrossRoad.freespinUnlockAreas.activateAnimation("top");
                DevilsCrossRoad.freespinCollectorView.playAnimation("sfs");
                DevilsCrossRoad.freespinUnlockAreas.activateAnimation("right");
            }

            RestoreUtils.normalStartUp();
        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {

        //DevilsCrossRoad.reelView.initReels(DevilsCrossRoad.model.data.reels, 6);
        //DevilsCrossRoad.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(DevilsCrossRoad.model.data.reels), DevilsCrossRoad.reelView.startPositions);

    }

}